interface IState {
  parcelIDs: number[];
  companyID: number | null;
}

interface IAction {
  type: 'ADD_PARCEL_ID' | 'CLEAR_PARCEL_IDS' | 'REMOVE_PARCEL_ID' | 'UPDATE_COMPANY_ID';
  payload: number;
}

const initState: IState = {
  parcelIDs: [],
  companyID: null,
};

export default function paymentsReducer(state: IState = initState, action: IAction): IState {
  if (action.type === 'ADD_PARCEL_ID') {
    return { ...state, parcelIDs: Array.from(new Set([...state.parcelIDs, action.payload])) };
  }

  if (action.type === 'UPDATE_COMPANY_ID') {
    return { ...state, companyID: action.payload };
  }

  if (action.type === 'CLEAR_PARCEL_IDS') {
    return { ...state, parcelIDs: [], companyID: null };
  }

  if (action.type === 'REMOVE_PARCEL_ID') {
    return { ...state, parcelIDs: state.parcelIDs.filter((parcelID) => parcelID !== action.payload) };
  }

  return state;
}
